/**
 * @description clips a time to be within a start and end time
 */

export const clipDate = ({ date, start, end }: { date: Date; start: Date; end: Date }) => {
  if (date < start) {
    return start;
  }
  if (date > end) {
    return end;
  }
  return date;
};
